import { Options } from '@sheerid/jslib';
import { RecursivePartial } from './lib/types/types';


export const programId = '5f99da3610e8e91938df9549';

export const defaultOptions: RecursivePartial<Options> = {
    restApi: {
        serviceUrl: 'https://services.sheerid.com',
    },
    logLevel: 'error',
    useFingerprinting: true,
};
